import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const ConfigurationListModal = ({
  show,
  onHide,
  onReset,
  onKeyDownHandler,
  searchVal,
  updateInputValue,
  showReset,
  onResetHandler,
  handleClick,
  onSort,
  configList,
  sort,
  commonUtiles,
  loading,
  renderBody,
  pageChange,
  Helpers,
  pageSize,
  isPrevBtnActive,
  configData,
  btnPrevClick,
  isNextBtnActive,
  btnNextClick,
}) => (
  <>
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      className="modal fade"
      dialogClassName="modal-dialog-centered"
    >
      <div
        id="configurationListModal"
        style={{
          marginLeft: "-55px",
          marginTop: "5%",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="d-flex changepass-title mb-0">
              <h2 className="text-white text-uppercase text-start">Configuration List</h2>
              <div className="close-icon text-end mt-5">
                <button type="button" className="close" onClick={onReset}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>

            <div className="modal-body" style={{ padding: 0, marginTop: "-10px" }}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="form-group has-search">
                  <span className="fa fa-search form-control-feedback" />
                  <input
                    id="searchVal"
                    type="text"
                    className="form-control"
                    onKeyDown={onKeyDownHandler}
                    value={searchVal}
                    onChange={updateInputValue}
                    placeholder="Search for Name"
                  />
                  {showReset && (
                    <i
                      aria-hidden="true"
                      className="fa fa-times close-icon"
                      onClick={onResetHandler}
                      onKeyDown={handleClick}
                      role="button"
                      tabIndex={0}
                    />
                  )}
                </div>
              </div>

              <div className="mt-4 table-max">
                <table className="table table-dark table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" className="header-sticky border-top-0 text-uppercase">
                        <span
                          onClick={() => onSort("configName", configList)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") onSort("configName", configList);
                          }}
                          role="button"
                          tabIndex={0}
                          className="cursor-pt"
                        >
                          Name
                        </span>
                        <span
                          className={commonUtiles.setArrow(sort, "configName")}
                          onClick={() => onSort("configName", configList)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") onSort("configName", configList);
                          }}
                          role="button"
                          tabIndex={0}
                        />
                      </th>
                      <th className="header-sticky text-uppercase border-top-0 header-50"> </th>
                    </tr>
                  </thead>
                  {loading ? (
                    <tbody>
                      <tr>
                        <td colSpan={2}>
                          <div className="mt-5 mb-5">
                            <div className="loader m-auto" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>{renderBody()}</tbody>
                  )}
                </table>
              </div>

              {!loading && (
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb flex-end mb-0 py-0 px-0 mt-4">
                    <li>
                      <Select
                        onChange={pageChange}
                        options={Helpers.getPageSizes}
                        name="role"
                        className="select-xsdd me-3"
                        autoFocus={false}
                        isSearchable={false}
                        value={pageSize}
                        styles={Helpers.getDropDownStyleForPage()}
                        menuPlacement="top"
                      />
                    </li>
                    {isPrevBtnActive === "disabled" || !configData?.length ? (
                      <li className="breadcrumb-item disable" aria-current="page">
                        <div className="disable">Prev</div>
                      </li>
                    ) : (
                      <li className="breadcrumb-item" aria-current="page">
                        <a href="#" onClick={btnPrevClick}>
                          Prev
                        </a>
                      </li>
                    )}
                    <div className="pipe">|</div>
                    {isNextBtnActive === "disabled" || !configData?.length ? (
                      <li className="breadcrumb-item">
                        <div className="disable">Next</div>
                      </li>
                    ) : (
                      <li className="breadcrumb-item">
                        <a href="#" onClick={btnNextClick}>
                          Next
                        </a>
                      </li>
                    )}
                  </ol>
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </>
);

export default ConfigurationListModal;
